export default __webpack_public_path__ + "static/media/goshen57.0527d576.JPG";